var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.container},_vm._l((_vm.archivedPublications),function(publication,i){return _c('PublicationRecord',{key:publication.uniquePublicationId,attrs:{"index":i,"publication":publication}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }